module.exports = __webpack_public_path__ + "static/media/2025-04-07_NIZ_Tagesschau_720p.f1116b87.mp4";